export default __webpack_public_path__ + "static/media/glenn_begley.73fe2f82.jpg";